import styled from '@emotion/styled';

import FONT from '../../../../styles/emotion/fonts';
import MEDIA_QUERY from '../../../../styles/emotion/mediaQueryV2';
import { Container, IosBadgeLink } from '../../../Footer/MobileApps.styles';

export const ZolaInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 40px;
  width: 33%;

  ${MEDIA_QUERY.EXCLUDE_DESKTOP} {
    width: 100%;
    padding: 32px 24px 40px;
  }
`;

export const StyledH5 = styled.h5`
  margin-top: 8px;
  margin-bottom: 24px;
  font-family: ${FONT.FONT_FAMILY_CIRCULAR};
  font-weight: ${FONT.FONT_WEIGHT_MEDIUM};
  font-size: ${FONT.FONT_SIZE_REGULAR};
  letter-spacing: normal;

  ${MEDIA_QUERY.EXCLUDE_DESKTOP} {
    font-size: ${FONT.FONT_SIZE_SMALL};
  }
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  margin-bottom: 24px;

  // Mobile Apps container
  ${Container} {
    border-bottom: none;
  }

  ${IosBadgeLink} {
    img {
      padding: 0;

      ${MEDIA_QUERY.MOBILE_XS}
      height: 44px;
    }
  }
`;

export const AppLinkWrapper = styled.div`
  text-align: center;
  img {
    max-width: 150px;
    height: 44px;

    ${MEDIA_QUERY.MOBILE_XS} {
      height: 38px;
    }
  }
`;

export const SocialWrapper = styled.div`
  svg,
  span {
    vertical-align: middle;
    display: inline-block;
  }
`;

export const SocialHandle = styled.span`
  margin-left: 8px;
  font-size: ${FONT.FONT_SIZE_SMALLER};
`;
